export default {
  sm: `
  LEED: Leadership in Energy and
  Environmental Design
  `,
  lg: `
  LEED: Leadership in Energy and Environmental Design
  `
};
